import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import CloseSubProjectWidget from '../../../widgets/closeProject/CloseSubProjectWidget'
import { getSubprojectCloseOfProjectForm } from '../../../redux/actions/closeOfProject'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'

export default function CloseProject(props) {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSubprojectCloseOfProjectForm(proposalId)
      setSchema(_schema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProject>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProject>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isSubProject>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />

          {showEditAll && (
            <BtnEditAll
              onClickEditAll={getIsEditAll(isEditWidget)}
              setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
            />
          )}

          {schema?.forms?.agreementDetails && (
            <AgreementAdditionalWidgets
              showCommandButton={true}
              formSchema={schema.forms.agreementDetails}
            />
          )}

          {schema?.forms?.requestNote && (
            <CloseSubProjectWidget
              disabledForm={schema.forms.requestNote.disabled}
              schema={schema.forms.requestNote}
              isEdit={isEditWidget.requestNote}
              attachments={schema.forms.attachments || []}
            />
          )}

          <br />
        </SidebarProposal>
      )}
    </>
  )
}
